import '@/assets/styles/global/index.scss';
import GhModal from '@/components/base/GhModal.vue';
import GhTooltip from '@/components/base/GhTooltip.vue';
import ListItem from '@/components/base/ListItem.vue';
import SvgIcon from '@/components/base/SvgIcon.vue';
import TourTooltip from '@/components/base/TourTooltip.vue';
import PrintService from '@/components/print/PrintService.vue';
import { installSharedRuntimeBridges } from '@/main';
import { registerRuntimeComponents } from '@/runtime/components/register-components.runtime';
import { installPortfolioShareRuntime } from '@/runtime/portfolio/install-portfolio-share.runtime';

let isInstalled = false;

/**
 * 安裝 _Layout 共用 runtime
 */
const installLayoutDefaultRuntime = (): void => {
    if (isInstalled) return;

    installSharedRuntimeBridges();
    registerRuntimeComponents({
        'gh-modal': GhModal,
        'gh-tooltip': GhTooltip,
        'list-item': ListItem,
        'svg-icon': SvgIcon,
        'tour-tooltip': TourTooltip,
        'print-service': PrintService,
    });

    isInstalled = true;
};

installLayoutDefaultRuntime();

installPortfolioShareRuntime();
